import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { ModalModule, ModalDirective } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import * as $ from 'jquery';
import { Section1Component } from "app/admin/section1/section1.component";

@Component({
    selector: 'app-new-section1-modal',
    templateUrl: './new-section1-modal.component.html',
    styleUrls: ['./new-section1-modal.component.scss']
})
export class NewSection1ModalComponent implements OnInit {
    @ViewChild('newsection1', {static: true}) public modal: ModalDirective;
    @ViewChild('modalContent', {static: true}) modalContent: ElementRef;
    parent: Section1Component;
    text: string = "";
    actionEdit: boolean = false;
    actionCreate: boolean = false;
    currentIndex: number;

  @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
  }

  show(text: string, parent: any, action, index): void {
      $('textarea').val(text);
      this.text = text;
      this.parent = parent;
      this.currentIndex = index;
      switch (action) {
          case "edit":
              this.actionEdit = true;
              break;
          case "create":
              this.actionCreate = true;
              break;
      }
      this.modal.show();
  }

  onShown(): void {
  }

  close(): void {
      this.modal.hide();
      this.resetActions();
  }

  resetActions() {
      this.actionCreate = false;
      this.actionEdit = false;
  }

  saveQuestion(text: string) {
      this.questionEmpty(text);
      //this.parent.insertNewRow(text);
      this.close();
  }

  editQuestion(text: string) {
      this.questionEmpty(text);
      //this.parent.editRow(text, this.currentIndex);
      this.close();
  }

  questionEmpty(text) {
      if (text == "") {
          $('#textarea').addClass('empty');
          setTimeout(function () {
              $('#textarea').removeClass('empty');
          }, 500);
          return;
      }
  }

}

interface HTMLInputEvent extends Event {
    target: HTMLInputElement & EventTarget;
}
